import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export interface MyOverallHighlightsTooltipProps {
    title: string;
    description: string;
}

const MyOverallHighlightsTooltip: FC<MyOverallHighlightsTooltipProps> = ({
    title,
    description
}: MyOverallHighlightsTooltipProps) => (
    <>
        <Typography variant="caption" color="textSecondary">
            {title}
        </Typography>
        <Box mt={4}>
            <Typography variant="caption" color="textSecondary">
                {description}
            </Typography>
        </Box>
    </>
);

export default MyOverallHighlightsTooltip;
